import React, {useEffect} from "react";
import { useState } from "react";
import {useHistory} from "react-router-dom";
import NavigationBar from "../UserProfile/navBar";
import EditProfileForm from "./profileForm";
import axios from "axios";
import EditProfileComponent from "./EditProfileComponent";

// Handles Edit Profile feature.
const EditProfile = () => {
    const [user, setUser] = useState('');
    const history = useHistory();

    //this hook checks if the user is logged in. If not the user is redirected to the home page.
    useEffect( () =>{
        axios.get('  https://food-mafia-server.herokuapp.com/api/checkLogin').
            then(response => 
                    setUser(response.data)   
            ).catch((e) => {
                alert("Login before accessing the page!");
                history.push("/home")
            });
        }, []);
    //console.log(user)
    return(
        <>
            <NavigationBar/>
            <EditProfileComponent user={user}/>
            <EditProfileForm user={user}/>
        </>
    )
}

export default EditProfile;